import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { labels } from "../../../../../../../../localization/labels";
import DropDown from "../../../../../../../core/DropDown";
import ClassificationTypeLookup from "../../../../../../Lookups/ClassificationTypeLookup";

const ClassificationAdditionalData = props => {
  return (
    <>
      <Form.Group
        controlId="classificationStatus"
        className="form-group required"
      >
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.status}</Form.Label>
          </Col>
          <Col>
            <DropDown
              value={props.entity.classificationStatus}
              options={props.statuses.map(x => ({
                value: x,
                label: x.name
              }))}
              onChange={props.onChange}
              targetId={"classificationStatus"}
              placeholder={labels.statusPlaceholder}
              required={props.validationRules.classificationStatus?.required}
            />
          </Col>
        </Row>
      </Form.Group>
      <Form.Group
        controlId="classificationType"
        className="form-group required"
      >
        <Row>
          <Col sm="2">
            <Form.Label className="Label">{labels.type}</Form.Label>
          </Col>
          <Col>
            <ClassificationTypeLookup
              onChange={props.onChange}
              controlId="classificationType"
              selected={props.entity.classificationType}
              messageHandler={props.messageHandler}
              required={props.validationRules?.classificationType?.required}
            />
          </Col>
        </Row>
      </Form.Group>

      {props.entity.classificationType ? (
        <Form.Group controlId="classificationParent" className="form-group">
          <Row>
            <Col sm="2">
              <Form.Label className="Label">{labels.parent}</Form.Label>
            </Col>
            <Col>
              <DropDown
                value={props.entity.parent}
                options={props.possibleParents.map(x => ({
                  value: x,
                  label: x.name
                }))}
                onChange={props.onChange}
                targetId={"parent"}
                placeholder={labels.parentPlaceholder}
                isClearable={true}
              />
            </Col>
          </Row>
        </Form.Group>
      ) : null}
    </>
  );
};

export default ClassificationAdditionalData;
